/**
 * The one scenario Environment the backend site serves.
 *
 * Each pam-deacon App Service slot reads a single Snowflake database (preview:
 * UAT, production: PROD) and answers 400 to any other ``env`` on a save, a run or
 * a lookup. REACT_APP_DB_ENV names that database at build time (``.env.preview``,
 * ``.env.production``), so the forms default to it and offer nothing else.
 */
export const SITE_ENV = (process.env.REACT_APP_DB_ENV || 'uat').toUpperCase();

/**
 * Environment choices for a form. A stored config from another environment keeps
 * its value visible (the server refuses it, with a message that says why) but
 * cannot be chosen.
 */
export const envChoices = (current) =>
  current && current !== SITE_ENV
    ? [{ value: SITE_ENV }, { value: current, disabled: true }]
    : [{ value: SITE_ENV }];
